import Image from 'next/image';

import { Box, Button } from '@zillow/constellation-10';
import { IconPlusFilled } from '@zillow/constellation-icons';

import { HOME_MIDWEST_STYLE_ILLUSTRATION_URL } from '../../../constants/DigitalLibraryConstants';

import EmptyState from '../../EmptyState';

type Props = {
  onAddPropertyClick: () => void;
};

export const FlexiblePropertyEmptyState = ({ onAddPropertyClick }: Props) => {
  return (
    <Box
      css={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        paddingInline: '400',
        paddingBlock: '400',
        width: '100%',
        minHeight: { xxl: '464px' },
      }}
    >
      <EmptyState
        useCard={false}
        align="center"
        data-testid="FlexiblePropertyEmptyState"
        icon={<Image alt="" role="presentation" src={HOME_MIDWEST_STYLE_ILLUSTRATION_URL} width={120} height={120} />}
        heading="Manage your rentals with confidence"
        body="Add your first property to start finding tenants, collecting payments, signing leases, and more."
        actions={
          <Button
            tone="brand"
            emphasis="filled"
            icon={<IconPlusFilled />}
            iconPosition="start"
            onClick={onAddPropertyClick}
            data-testid="FlexiblePropertyEmptyStateAddButton"
          >
            Add property
          </Button>
        }
      />
    </Box>
  );
};
